<template>
  <el-dialog
    v-drag
    v-loading="loading"
    :visible.sync="dialogVisible"
    width="500px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <span slot="title">
      {{ `查看在途提单(${rowData?.inTransitMbl})` }}
      <span class="tips">{{ rowData?.name }}</span>
    </span>
    <div class="content">
      <div class="data">
        <BaseTable
          :height="400"
          :tableData="tableData"
          :isPager="false"
        >
        </BaseTable>
      </div>
    </div>
  </el-dialog>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable.vue')
import { getImporterInTransitMbl } from '@/api/system'
export default {
  components: { BaseTable },
  props: {
    dialogVisible: Boolean,
    rowData: Object
  },
  data() {
    return {
      loading: false,
      tableData: {
        fileds: [
          {
            filed: 'mblNo',
            label: '提单号',
            width: ''
          },
          {
            filed: 'eta',
            label: 'ETA',
            width: ''
          }
        ],
        columns: [],
        showIndex: true
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getList()
      }
    }
  },
  methods: {
    async getList() {
      try {
        this.loading = true
        const res = await getImporterInTransitMbl({
          importerId: this.rowData.id
        })
        this.loading = false
        if (res.success) {
          this.tableData.columns = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="less" scoped>
.tips {
  display: inline-block;
  padding: 0 10px;
  color: #165DFF;
  font-size: 12px;
  background: #E8F3FF;
  border-radius: 4px 4px 4px 4px;
}
.content {
  width: 100%;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    .label {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      margin-right: 7px;
    }
    .upload-file {
      display: flex;
      align-items: center;
      .upload-btn {
        img {
          margin-right: 10px;
        }
      }
      /deep/ .el-upload-dragger {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 268px;
        height: 40px;
        background: #f7f7f7;
        border-radius: 4px 4px 4px 4px;
        border: 0;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #142e79;
      }
    }
  }
}
</style>
